import {
    SET_STEP_INDEX,
    SET_USER_VALID
} from './actionTypes';

export const setStepIndex = value => (
    {
        type: SET_STEP_INDEX,
        newValue: value
    }
);

export const setUserValid = (value) => ({
  type: SET_USER_VALID,
  newValue: value
});
